module.exports = __webpack_public_path__ + "img/4_2.bc0a02fd.png";